/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import { Button, Container, Form, Modal, OverlayTrigger, Tooltip, Card, Col, Row } from 'react-bootstrap';
import { NavBar } from "../NavBar";
import { AgGridReact } from 'ag-grid-react';
import "../../CSS/general.css";
import Axios from "axios";
import { API_ROUTE, Routes} from "../../Helpers/Constants";
import AuthenticationContext from "../../Store/Authentication-Context";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoaderGif from "../../images/365 loading.gif";
import { InfoCircle } from 'react-bootstrap-icons';


const PriceListPopUpModal = ({ showModal, handleClose, modalHeader, modalBody, modalFooter, selecteddata }) => {

    return (
        <>
            {showModal && (
                <Modal show={showModal} onHide={handleClose} backdrop="static" size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <>
                                {modalHeader}
                                {modalHeader.includes("DELETE PRICE MODEL") && (<span style={{ color: '#f00', fontSize: '1.5rem' }}>
                                    &nbsp;&nbsp;Note: Make sure no organisation is mapped to it.
                                </span>)}
                            </>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{modalBody}</Modal.Body>
                    <Modal.Footer>
                        {modalFooter}
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
};

const PriceManagement = () => {

    const config = async () => {
        const tokenString = await setAuthContext("", new Date());
        return {
            headers: {
                Authorisation: `Bearer ${tokenString}`,
                CloudCoverToken: sessionStorage.getItem("CloudCoverToken"),
            },
        };

    };

    const { setAuthContext } = useContext(AuthenticationContext);
    const authContext = useContext(AuthenticationContext);
    const [resellersData, setResellersData] = useState([]);
    
    const [modalBody, setModalBody] = useState();
    const [modalHeader, setModalHeader] = useState();
    const [modalFooter, setModalFooter] = useState();
    
    
    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
    }), []);

    //price model
    const [modelColDef, setModelColDef] = useState([]);
    const [gridPmApi, setGridPmApi] = useState(null);
    ////const [gridPmColumnApi, setGridPmColumnApi] = useState(null);
    const [modelData, setModelData] = useState([]);
    const [modelLoading, setModelLoading] = useState(false);
    const defaultPriceModel = {
        name: '',
        description: '',
        resellerId: '',
        term: '',
        family: '',
        partnerDiscount: '',
        payg: '',
        invoiceDesc: '',
        cwDirectProductID: '',
        cwPartnerProductID: '',
        paygPartnerDiskDiscount: '',
        isResellerEnabled: false,
        active: false,
        hideInPricelist: false,
        nonSelectable: false,
        weightage: '',
    };
    const [selectedPriceModel, setSelectedPriceModel] = useState(defaultPriceModel);
    const defaultPmValidation = {
        isNameValid: true,
        nameErrorMessage: '',

        isDescriptionValid: true,
        descriptionErrorMessage: '',

        isResellerIDValid: true,
        resellerIDErrorMessage: '',

        isTermValid: true,
        termErrorMessage: '',

        isFamilyValid: true,
        familyErrorMessage: '',

        isPartnerDiscountValid: true,
        partnerDiscountErrorMessage: '',

        isPaygValid: true,
        paygErrorMessage: '',

        isInvoiceDescValid: true,
        invoiceDescErrorMessage: '',

        isCWDirectProductIDValid: true,
        cwDirectProductIDErrorMessage: '',

        isCWPartnerProductIDValid: true,
        cwPartnerProductIDErrorMessage: '',

        isPAYGPartnerDiskDiscountValid: true,
        paygPartnerDiskDiscountErrorMessage: '',

        isWeightingValid: true,
        weightingErrorMessage: '',

        isWeightageValid: true,
        weightageErrorMessage: ''
    };
    const [pmValidation, setPmValidation] = useState(defaultPmValidation);

    //price feature
    const [featureColDef, setFeatureColDef] = useState([]);
    const gridPfRef = useRef();
    const [gridPfApi, setGridPfApi] = useState(null);
    ////const [gridPfColumnApi, setGridPfColumnApi] = useState(null);
    const [featureData, setFeatureData] = useState([]);
    const [featureLoading, setFeatureLoading] = useState(false);
    const defaultPriceFeature = {
        priceModelID: 0,
        featureName: '',
        featureDescription: '',
        sortOrder: 0,
        featureType: '',
        featureValue: '',
        featureUnit: '',
        smallPrint: false
    };
    const [selectedUpdatedFeature, setSelectedUpdatedFeature] = useState(defaultPriceFeature);
    const [selectedExistingFeature, setSelectedExistingFeature] = useState(defaultPriceFeature);
    const defaultPfValidation = {
        isPriceModelIDValid: true,
        priceModelIDErrorMessage: '',

        isFeatureNameValid: true,
        featureNameErrorMessage: '',

        isFeatureDescriptionValid: true,
        featureDescriptionErrorMessage: '',

        isSortOrderValid: true,
        sortOrderErrorMessage: '',

        isFeatureTypeValid: true,
        featureTypeErrorMessage: '',

        isFeatureValueValid: true,
        featureValueErrorMessage: '',

        isFeatureUnitValid: true,
        featureUnitErrorMessage: '',

        isSmallPrintValid: true, // Optional, for completeness
        smallPrintErrorMessage: ''
    };
    const [pfValidation, setPfValidation] = useState(defaultPfValidation);

    //price book
    const [bookColDef, setBookColDef] = useState([]);
    const [gridPbApi, setGridPbApi] = useState(null);
    ////const [gridPbColumnApi, setGridPbColumnApi] = useState(null);
    const [bookData, setBookData] = useState([]);
    const [bookLoading, setBookLoading] = useState(false);
    const [activeModelId, setActiveModelId] = useState(null);
    const defaultPriceBook = {
        name: '',
        accountCode: '',
        priceModelID: '',
        sband: '',
        eband: '',
        type: '',
        price: '',
        discount: '',
        currency: ''
    };
    const [selectedPriceBook, setSelectedPriceBook] = useState(defaultPriceBook);
    const defaultPbValidation = {
        isNameValid: true,
        nameErrorMessage: '',

        isAccountCodeValid: true,
        accountCodeErrorMessage: '',

        isPriceModelIDValid: true,
        priceModelIDErrorMessage: '',

        isSBandValid: true,
        sBandErrorMessage: '',

        isEBandValid: true,
        eBandErrorMessage: '',

        isTypeValid: true,
        typeErrorMessage: '',

        isPriceValid: true,
        priceErrorMessage: '',

        isDiscountValid: true,
        discountErrorMessage: '',

        isCurrencyValid: true,
        currencyErrorMessage: ''
    };
    const [pbValidation, setPbValidation] = useState(defaultPbValidation);

    const [showModal, setShowModal] = useState(false);

    const handleClose = () => {
        if (modalHeader.includes("FOR MODEL")) {
            clearAllPfFilters();
            clearAllPbFilters();
        }
        setShowModal(false);
        setModalHeader(null);
        setModalBody(null);
        setModalFooter(null);
        setSelectedPriceModel(defaultPriceModel);
        setSelectedExistingFeature(defaultPriceFeature);
        setSelectedUpdatedFeature(defaultPriceModel);
        setSelectedPriceBook(defaultPriceBook);
        setPmValidation(defaultPmValidation);
        setPfValidation(defaultPfValidation);
        setPbValidation(defaultPbValidation);
    };

    const modelNameMap = new Map(modelData.map(item => [item.id, item.name || ` `]));

    const resellerMap = new Map(resellersData.map(item => [item.resellerId, item.resellerName || ` `]));

    const renderTooltip = (props) => (

        <Tooltip id={`tooltip-${props.id}`} {...props}>
            {props.text}
        </Tooltip>

    );

    const booleanCellRenderer = (params) => {
        return (
            <input
                type="checkbox"
                disabled
                checked={params.value === true}
                readOnly
            />
        );
    };

    const blockInvalidChar = (e) => {
        if (['e', 'E', '+', '-'].includes(e.key)) {
            e.preventDefault();
        }
    };


    const handlePMNameChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, name: value }));
        setPmValidation(prev => ({
            ...prev,
            isNameValid: value.trim() !== '',
            nameErrorMessage: value.trim() !== '' ? 'Name is required' : ''
        }));
    };

    const handlePMDescriptionChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({
            ...prev,
            description: value
        }));
        setPmValidation(prev => ({
            ...prev,
            isDescriptionValid: value.trim() !== '',
            descriptionErrorMessage: value.trim() === ''
                ? 'Description is required'
                : ''
        }));
    };


    const handlePMResellerIdChange = (e) => {
        const value = e.target.value;
        const parsedValue = value ? Number(value) : ''; // Convert to number or empty string

        setSelectedPriceModel(prev => ({
            ...prev,
            resellerId: parsedValue
        }));
    };


    const handlePMTermChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, term: value }));
        if (value < 0) {
            setPmValidation(prev => ({
                ...prev,
                isTermValid: false,
                termErrorMessage: 'Term should not be negative'
            }));
        }
        else {
            setPmValidation(prev => ({
                ...prev,
                isTermValid: true,
                termErrorMessage: ''
            }));
        }
    };

    const handlePMFamilyChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, family: value }));
    };

    const handlePMPartnerDiscountChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, partnerDiscount: value }));
        if (value < 0) {
            setPmValidation(prev => ({
                ...prev,
                isPartnerDiscountValid: false,
                partnerDiscountErrorMessage: 'Partner discount should not be negative'
            }));
        }
    };

    const handlePMPaygChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, payg: value }));
        if(value < 0) {
            setPmValidation(prev => ({
                ...prev,
                isPaygValid: false,
                paygErrorMessage: value.trim() === '' ? 'PAYG value should not be negative' : ''
            }));
        }
    };

    const handlePMActiveChange = (e) => {
        const checked = e.target.checked;
        setSelectedPriceModel(prev => ({ ...prev, active: checked }));
        // No validation needed for checkbox
    };
    const handlePMIsResellerEnabledChange = (e) => {
        const checked = e.target.checked;
        setSelectedPriceModel(prev => ({ ...prev, isResellerEnabled: checked }));
        // No validation needed for checkbox
    };
    

    const handlePMInvoiceDescChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, invoiceDesc: value }));
    };

    const handlePMCWDirectProductIDChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, cwDirectProductID: value }));
    };

    const handlePMCWPartnerProductIDChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, cwPartnerProductID: value }));
        if (value < 0) {
            setPmValidation(prev => ({
                ...prev,
                isCWPartnerProductIDValid: value.trim() !== '',
                cwPartnerProductIDErrorMessage: value.trim() === '' ? 'CW Partner Product ID is required' : ''
            }));
        }
    };

    const handlePMPAYGPartnerDiskDiscountChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, paygPartnerDiskDiscount: value }));
        setPmValidation(prev => ({
            ...prev,
            isPAYGPartnerDiskDiscountValid: value.trim() !== '',
            paygPartnerDiskDiscountErrorMessage: value.trim() === '' ? 'PAYG Partner Disk Discount is required' : ''
        }));
    };

    const handlePMHideInPricelistChange = (e) => {
        const checked = e.target.checked;
        setSelectedPriceModel(prev => ({ ...prev, hideinPricelist: checked }));
        // No validation needed for checkbox
    };

    const handlePMNonSelectableChange = (e) => {
        const checked = e.target.checked;
        setSelectedPriceModel(prev => ({ ...prev, nonSelectable: checked }));
        // No validation needed for checkbox
    };

    const handlePMWeightageChange = (e) => {
        const value = e.target.value;
        setSelectedPriceModel(prev => ({ ...prev, weightage: value }));
        const isValid = !isNaN(parseFloat(value)) && isFinite(value);
        if (value === "") {
            setPmValidation(prev => ({
                ...prev,
                isWeightageValid: isValid,
                weightageErrorMessage: isValid ? '' : 'Weightage is required'
            }));
}
        else if (value < 0) {
            setPmValidation(prev => ({
                ...prev,
                isWeightageValid: isValid,
                weightageErrorMessage: isValid ? '' : 'Weightage should not be negative'
            }));
        }
    };

    //handler for Price Feature...
    const handlePFPriceModelIdChange = (e) => {
        const value = e.target.value;
        const parsed = parseInt(value, 10) || 0;
        setSelectedUpdatedFeature(prev => ({
            ...prev,
            priceModelID: parsed
        }));
        setPfValidation(prev => ({
            ...prev,
            isPriceModelIDValid: parsed > 0,
            priceModelIDErrorMessage: parsed > 0 ? '' : 'Price Model must be selected'
        }));
    };

    const handlePFFeatureNameChange = (e) => {
        const value = e.target.value;
        setSelectedUpdatedFeature(prev => ({
            ...prev,
            featureName: value
        }));
        setPfValidation(prev => ({
            ...prev,
            isFeatureNameValid: value.trim() !== '',
            featureNameErrorMessage: value.trim() === '' ? 'Feature name is required..' : ''
        }));
    };

    const handlePFFeatureDescriptionChange = (e) => {
        const value = e.target.value;
        setSelectedUpdatedFeature(prev => ({
            ...prev,
            featureDescription: value
        }));
        setPfValidation(prev => ({
            ...prev,
            isFeatureDescriptionValid: value.trim() !== '',
            featureDescriptionErrorMessage: value.trim() === '' ? 'Feature description is required' : ''
        }));
    };

    const handlePFSortOrderChange = (e) => {
        const value = e.target.value;
        const parsed = parseInt(value, 10) || 0;
        setSelectedUpdatedFeature(prev => ({
            ...prev,
            sortOrder: parsed
        }));
        setPfValidation(prev => ({
            ...prev,
            isSortOrderValid: parsed >= 0,
            sortOrderErrorMessage: parsed >= 0 ? '' : 'Sort order must be a non-negative number'
        }));
    };

    const handlePFFeatureTypeChange = (e) => {
        const value = e.target.value;
        setSelectedUpdatedFeature(prev => ({
            ...prev,
            featureType: value
        }));
        setPfValidation(prev => ({
            ...prev,
            isFeatureTypeValid: value.trim() !== '',
            featureTypeErrorMessage: value.trim() === '' ? 'Feature type is required' : ''
        }));
    };

    const handlePFFeatureValueChange = (e) => {
        const value = e.target.value;
        setSelectedUpdatedFeature(prev => ({
            ...prev,
            featureValue: value
        }));
        setPfValidation(prev => ({
            ...prev,
            isFeatureValueValid: value.trim() !== '',
            featureValueErrorMessage: value.trim() === '' ? 'Feature value is required' : ''
        }));
    };

    const handlePFFeatureUnitChange = (e) => {
        const value = e.target.value;
        setSelectedUpdatedFeature(prev => ({
            ...prev,
            featureUnit: value
        }));
        setPfValidation(prev => ({
            ...prev,
            isFeatureUnitValid: value.trim() !== '',
            featureUnitErrorMessage: value.trim() === '' ? 'Feature unit is required' : ''
        }));
    };

    const handlePFSmallPrintChange = (e) => {
        const checked = e.target.checked;
        setSelectedUpdatedFeature(prev => ({
            ...prev,
            smallPrint: checked
        }));
        // No validation required for checkbox
    };

    const handlePBNameChange = (e) => {
        const value = e.target.value;
        setSelectedPriceBook({ ...selectedPriceBook, name: value });
        setPbValidation(prev => ({
            ...prev,
            isNameValid: value.trim() !== '',
            nameErrorMessage: value.trim() === '' ? 'Name should not be empty' : ''
        }));
    };

    const handlePBAccountCodeChange = (e) => {
        const value = e.target.value;
        setSelectedPriceBook({ ...selectedPriceBook, accountCode: value });
        setPbValidation(prev => ({
            ...prev,
            isAccountCodeValid: value.trim() !== '',
            accountCodeErrorMessage: value.trim() === '' ? 'Account code is required' : ''
        }));
    };

    const handlePBPriceModelIDChange = (e) => {
        const value = e.target.value;
        setSelectedPriceBook({ ...selectedPriceBook, priceModelID: value });
        setPbValidation(prev => ({
            ...prev,
            isPriceModelIDValid: value.trim() !== '',
            priceModelIDErrorMessage: value.trim() === '' ? 'Price Model must be selected' : ''
        }));
    };

    const handlePBSBandChange = (e) => {
        let value = e.target.value;
        if (value === 'e')
            value = '';
        setSelectedPriceBook({ ...selectedPriceBook, sband: value });
        if(value < 0)
            setPbValidation(prev => ({
                ...prev,
                isSBandValid: false,
                sBandErrorMessage: "Start Band's Value should be negeative" 
            }));
    };

    const handlePBEBandChange = (e) => {
        const value = e.target.value;
        setSelectedPriceBook({ ...selectedPriceBook, eband: value });
        if (value < 0)
            setPbValidation(prev => ({
                ...prev,
                isEBandValid: false,
                eBandErrorMessage: "End Band's Value should be negeative"
            }));
    };

    const handlePBTypeChange = (e) => {
        const value = e.target.value;
        setSelectedPriceBook({ ...selectedPriceBook, type: value });
        setPbValidation(prev => ({
            ...prev,
            isTypeValid: value.trim() !== '',
            typeErrorMessage: value.trim() === '' ? 'Type is not blank' : ''
        }));
    };

    const handlePBPriceChange = (e) => {
        const value = e.target.value;
        setSelectedPriceBook({ ...selectedPriceBook, price: value });
        const isValid = !isNaN(parseFloat(value)) && isFinite(value);
        setPbValidation(prev => ({
            ...prev,
            isPriceValid: isValid,
            priceErrorMessage: isValid ? '' : 'Price must be a valid number'
        }));
    };

    const handlePBDiscountChange = (e) => {
        const value = e.target.value;
        setSelectedPriceBook({ ...selectedPriceBook, discount: value });
        const isValid = !isNaN(parseFloat(value)) && isFinite(value);
        setPbValidation(prev => ({
            ...prev,
            isDiscountValid: isValid,
            discountErrorMessage: isValid ? '' : 'Discount must be a valid number'
        }));
    };

    const handlePBCurrencyChange = (e) => {
        const value = e.target.value;
        setSelectedPriceBook({ ...selectedPriceBook, currency: value });
        setPbValidation(prev => ({
            ...prev,
            isCurrencyValid: value.trim() !== '',
            currencyErrorMessage: value.trim() === '' ? 'Currency is required' : ''
        }));
    };

    const confirmDeletePm = async (params) => {
        setShowModal(true);
        setSelectedPriceModel(params.node.data);
        setModalHeader('DELETE PRICE MODEL :');
        setModalBody("Are you sure you want to delete this");
        setModalFooter(footerButtons("DELETE",
            () => {
                DeletePM(params)
            }
        ));
    }

    const DeletePM = async (params) => {
        try {
            setModelLoading(true);
            const priceModelId = params.id;
            await Axios.get(API_ROUTE + Routes.DELETE_PRICE_MODEL + '/' + priceModelId, await config());
            getPriceDetails();
            handleClose();
            setSelectedPriceModel(defaultPriceModel);
            toast.success(`Price Model "${selectedPriceModel.name}" deleted successfully`);
        }
        catch (reason) {
            setModelLoading(false);
            handleClose();
            const errorMessage = reason?.response?.data|| "unable to delete Price Model.";
            toast.error(errorMessage);
        }
    }

    const confirmDeletePf = async (params) => {
        setShowModal(true);
        setSelectedUpdatedFeature(params.node.data);
        setModalHeader(`DELETE PRICE FEATURE :`);
        setModalBody('Are you sure you want to delete this');
        setModalFooter(footerButtons("DELETE",
            () => {
                DeletePF(params)
            }))
    }

    const DeletePF = async (params) => {
        try {
            setFeatureLoading(true);
            const { priceModelID, featureName, featureDescription } = params;
            await Axios.get(API_ROUTE + Routes.DELETE_PRICE_FEATURE + '/' + priceModelID + '/' + featureName + '/' + featureDescription, await config());
            reloadPriceFeature();
            handleClose();            
            toast.success(`Price Feature "${selectedUpdatedFeature.featureName}" deleted successfully.`);
        }
        catch (reason) {
            setFeatureLoading(false);
            handleClose();
            toast.error("Unable to delete Price Feature");

        }
    }

    const confirmDeletePb = async (params) => {
        setShowModal(true);
        setSelectedPriceBook(params.node.data);
        setModalHeader(`DELETE PRICE BOOK :`);
        setModalBody('Are you sure you want to delete this');
        setModalFooter(footerButtons("DELETE",
            () => {
                DeletePB(params)
            }))
    }

    const DeletePB = async (params) => {
        try {
            setBookLoading(true);
            const { id } = params;
            await Axios.get(API_ROUTE + Routes.DELETE_PRICE_BOOK + '/' + id, await config());
            reloadPriceBook();
            handleClose();
            toast.success(`Price Book "${selectedPriceBook.name}" deleted successfully.`);
        }
        catch (reason) {
            setBookLoading(false);
            handleClose();
            toast.error("Unable to delete Price Book");

        }
    }

    const getResellers = async () => {
        await Axios.post(API_ROUTE + Routes.GET_MASTERADMIN_RESELLERS, "", await config())
            .then((response) => {
                let responsedata = response.data;
                sessionStorage.setItem('Resellers', JSON.stringify(responsedata))
                setResellersData(responsedata);
            })
            .catch((reason) => {
                if (reason?.response?.status === 403) {
                    window.location.href = "/Unauthorized";
                }
                else if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }

    const savePriceModel = async () => {
        try {
            let payload = {
                id: selectedPriceModel.id ?? 0,
                name: selectedPriceModel.name ?? "",
                description: selectedPriceModel.description ?? "",
                resellerId: selectedPriceModel.resellerId === "" ? null : selectedPriceModel.resellerId,
                term: selectedPriceModel.term === "" ? 0 : Number(selectedPriceModel.term),
                family: selectedPriceModel.family ?? "",
                partnerDiscount: selectedPriceModel.partnerDiscount === "" ? null : Number(selectedPriceModel.partnerDiscount),
                payg: selectedPriceModel.payg === "" ? null : Number(selectedPriceModel.payg),
                active: selectedPriceModel.active ?? false,
                invoiceDesc: selectedPriceModel.invoiceDesc ?? "",
                cwDirectProductID: selectedPriceModel.cwDirectProductID ?? "",
                cwPartnerProductID: selectedPriceModel.cwPartnerProductID === "" ? null : Number(selectedPriceModel.cwPartnerProductID),
                paygPartnerDiskDiscount: selectedPriceModel.paygPartnerDiskDiscount === "" ? null : Number(selectedPriceModel.paygPartnerDiskDiscount),
                hideInPricelist: selectedPriceModel.hideinPricelist ?? false,
                isResellerEnabled: selectedPriceModel.resellerId !== "" && selectedPriceModel.resellerId.toString() !== "0" ? false : (selectedPriceModel.isResellerEnabled),

                nonSelectable: selectedPriceModel.nonSelectable ?? false,
                weightage: selectedPriceModel.weightage === "" ? 0 : Number(selectedPriceModel.weightage)
            };
            await Axios.post(API_ROUTE + Routes.SAVE_PRICE_MODEL, payload, await config())
                .then((response) => {
                    const message = modalHeader === "NEW PRICE MODEL"
                        ? "New Price Model created successfully"
                        : "Price Model edited successfully";
                    toast.success(message);
                    handleClose();
                    reloadPriceModel();
                    return response; 
                });

        }
        catch (reason) {
            toast.error("Unable to save PRICE MODEL");
            handleClose();
        }
    };

    const copyModelField = () => {
        return (<Form noValidate>
            <Form.Group className="mb-3" controlId="priceModelName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Price Model Name"
                    value={selectedPriceModel.name || ''}
                    isInvalid={!pmValidation.isNameValid}
                    onChange={handlePMNameChange}
                />
                <Form.Control.Feedback type="invalid">
                    {pmValidation.nameErrorMessage}
                </Form.Control.Feedback>
            </Form.Group>
        </Form>);
    };

    const copyPriceModel = async (params) => {
        setSelectedPriceModel({
            ...params.node.data,
            resellerId: params.node.data.resellerID,
            hideInPricelist: params.node.data.hideinPricelist,
        });
        setShowModal(true);
        setModalHeader("COPY PRICE MODEL");
        setModalBody(copyModelField);
        setModalFooter(footerButtons("CLONE",
            () => {
                clonePriceModel();
            }
        ));
    };

    const clonePriceModel = async () => {
        try {
            setModelLoading(true);
            let payload = {
                id: selectedPriceModel.id ?? 0,
                name: selectedPriceModel.name ?? "",
                description: selectedPriceModel.description ?? "",
                resellerId: selectedPriceModel.resellerId === "" ? null : selectedPriceModel.resellerId,
                term: selectedPriceModel.term === "" ? 0 : Number(selectedPriceModel.term),
                family: selectedPriceModel.family ?? "",
                partnerDiscount: selectedPriceModel.partnerDiscount === "" ? null : Number(selectedPriceModel.partnerDiscount),
                payg: selectedPriceModel.payg === "" ? null : Number(selectedPriceModel.payg),
                active: selectedPriceModel.active ?? false,
                invoiceDesc: selectedPriceModel.invoiceDesc ?? "",
                cwDirectProductID: selectedPriceModel.cwDirectProductID ?? "",
                cwPartnerProductID: selectedPriceModel.cwPartnerProductID === "" ? null : Number(selectedPriceModel.cwPartnerProductID),
                paygPartnerDiskDiscount: selectedPriceModel.paygPartnerDiskDiscount === "" ? null : Number(selectedPriceModel.paygPartnerDiskDiscount),
                hideInPricelist: selectedPriceModel.hideInPricelist ?? false,
                isResellerEnabled: selectedPriceModel.resellerId !== "" && selectedPriceModel.resellerId?.toString() !== "0" ? false : (selectedPriceModel.isResellerEnabled ?? false),
                nonSelectable: selectedPriceModel.nonSelectable ?? false,
                weightage: selectedPriceModel.weightage === "" ? 0 : Number(selectedPriceModel.weightage)
            };


            await Axios.post(API_ROUTE + Routes.CLONE_PRICE_MODEL, payload, await config());
            handleClose();
            getPriceDetails();
            setSelectedPriceModel(defaultPriceModel);
            toast.success("New Price Model clonned successfully")
        }
        catch (reason) {
            const message = "Failed to clonned NEW PRICE MODEL";
            toast.error(message);
            handleClose();
        }
    };

    const savePriceFeature = async () => {
        try {
            const payload = [
                selectedExistingFeature ? {
                    priceModelID: selectedExistingFeature.priceModelID ?? 0,
                    featureName: selectedExistingFeature.featureName ?? "",
                    featureDescription: selectedExistingFeature.featureDescription ?? "",
                    sortOrder: selectedExistingFeature.sortOrder ?? 0,
                    featureType: selectedExistingFeature.featureType ?? "",
                    featureValue: selectedExistingFeature.featureValue ?? "",
                    featureUnit: selectedExistingFeature.featureUnit ?? "",
                    smallPrint: selectedExistingFeature.smallPrint ?? false
                } : null,
                {
                    priceModelID: selectedUpdatedFeature.priceModelID ?? 0,
                    featureName: selectedUpdatedFeature.featureName ?? "",
                    featureDescription: selectedUpdatedFeature.featureDescription ?? "",
                    sortOrder: selectedUpdatedFeature.sortOrder ?? 0,
                    featureType: selectedUpdatedFeature.featureType ?? "",
                    featureValue: selectedUpdatedFeature.featureValue ?? "",
                    featureUnit: selectedUpdatedFeature.featureUnit ?? "",
                    smallPrint: selectedUpdatedFeature.smallPrint ?? false,
                }
            ];
            await Axios.post(API_ROUTE + Routes.SAVE_PRICE_FEATURE, payload, await config());
            const message = modalHeader === "NEW PRICE FEATURE" ? "New Price Feature created successfully" : "Price Feature edited successfully";
            handleClose();
            reloadPriceFeature();
            toast.success(message);
        }
        catch (reason) {
            const message = modalHeader === "NEW PRICE FEATURE"
                ? "Failed to create New Price Feature"
                : "Failed to edit Price Feature";
            toast.error(message);
            handleClose();
        }
    };

    const savePriceBook = async () => {
        try {
            const payload = {
                id: selectedPriceBook.id ?? 0,
                name: selectedPriceBook.name ?? "",
                accountCode: selectedPriceBook.accountCode ?? 0,
                priceModelID: selectedPriceBook.priceModelID ?? 0,
                sband: selectedPriceBook.sband ?? 0,
                eband: selectedPriceBook.eband ?? 0,
                type: selectedPriceBook.type ?? "",
                price: selectedPriceBook.price ?? 0.0,
                discount: selectedPriceBook.discount ?? 0.0,
                currency: selectedPriceBook.currency ?? ""
            };
            await Axios.post(API_ROUTE + Routes.SAVE_PRICE_BOOK, payload, await config());
            const message = modalHeader === "NEW PRICE BOOK" ? "New Price Book created successfully" : "Price Book edited successfully";
            handleClose();
            reloadPriceBook();
            toast.success(message);
        }
        catch (reason) {
            const message = modalHeader === "NEW PRICE BOOK"
                ? "Failed to create New Price Book"
                : "Failed to edit New Price Book";

            toast.error(message);
            handleClose();
        }
    };

    const modelField = () => {
        return (<Row>
            <Col md={6}>
                <Form noValidate>
                    <Form.Group className="mb-3" controlId="priceModelName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Price Model Name"
                            value={selectedPriceModel.name || ''}
                            isInvalid={!pmValidation.isNameValid}
                            onChange={handlePMNameChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.nameErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="priceModelDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Description"
                            value={selectedPriceModel.description || ''}
                            isInvalid={!pmValidation.isDescriptionValid}
                            onChange={handlePMDescriptionChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.descriptionErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="priceModelReseller">
                        <Form.Label>Reseller</Form.Label>
                        <Form.Select
                            value={String(selectedPriceModel.resellerId ?? '')}
                            isInvalid={pmValidation.isResellerIdValid}
                            onChange={handlePMResellerIdChange}
                        >
                            <option value="0">Select Reseller</option>
                            {resellersData.map((reseller, index) => (
                                <option
                                    key={reseller.resellerId ?? `reseller-${index}`}
                                    value={String(reseller.resellerId)}
                                >
                                    {reseller.resellerName || ' '}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="term">
                        <Form.Label>Term</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Term"
                            value={selectedPriceModel.term ?? ''}
                            isInvalid={!pmValidation.isTermValid}
                            onChange={handlePMTermChange}
                            onKeyDown={blockInvalidChar}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.termErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="family">
                        <Form.Label>Family</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Family"
                            value={selectedPriceModel.family || ''}
                            isInvalid={!pmValidation.isFamilyValid}
                            onChange={handlePMFamilyChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.familyErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="partnerDiscount">
                        <Form.Label>Partner Discount (%)</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Partner Discount"
                            value={selectedPriceModel.partnerDiscount ?? ''}
                            isInvalid={!pmValidation.isPartnerDiscountValid}
                            onChange={handlePMPartnerDiscountChange}
                            onKeyDown={blockInvalidChar}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.partnerDiscountErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="payg">
                        <Form.Label>PAYG</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="PAYG"
                            value={selectedPriceModel.payg ?? ''}
                            isInvalid={!pmValidation.isPaygValid}
                            onChange={handlePMPaygChange}
                            onKeyDown={blockInvalidChar}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.paygErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Col>

            <Col md={6}>
                <Form noValidate>
                    <Form.Group className="mb-3" controlId="invoiceDesc">
                        <Form.Label>Invoice Description</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Invoice Description"
                            value={selectedPriceModel.invoiceDesc || ''}
                            isInvalid={!pmValidation.isInvoiceDescValid}
                            onChange={handlePMInvoiceDescChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.invoiceDescErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="cwDirectProductId">
                        <Form.Label>CW Direct Product ID</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="CW Direct Product ID"
                            value={selectedPriceModel.cwDirectProductID || ''}
                            isInvalid={!pmValidation.isCWDirectProductIDValid}
                            onChange={handlePMCWDirectProductIDChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.cwDirectProductIDErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="cwPartnerProductId">
                        <Form.Label>CW Partner Product ID</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="CW Partner Product ID"
                            value={selectedPriceModel.cwPartnerProductID ?? ''}
                            isInvalid={!pmValidation.isCWPartnerProductIDValid}
                            onChange={handlePMCWPartnerProductIDChange}
                            onKeyDown={blockInvalidChar}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.cwPartnerProductIDErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="paygPartnerDiskDiscount">
                        <Form.Label>PAYG Partner Disk Discount (%)</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="PAYG Partner Disk Discount"
                            value={selectedPriceModel.paygPartnerDiskDiscount ?? ''}
                            isInvalid={!pmValidation.isPAYGPartnerDiskDiscountValid}
                            onChange={handlePMPAYGPartnerDiskDiscountChange}
                            onKeyDown={blockInvalidChar}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.paygPartnerDiskDiscountErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3 d-flex align-items-center" controlId="isResellerEnabled">
                        <Form.Check.Input
                            type="checkbox"
                            style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                            }}
                            checked={
                                selectedPriceModel.resellerId !== 0
                                    ? false
                                    : !!selectedPriceModel.isResellerEnabled
                            }
                            onChange={handlePMIsResellerEnabledChange}
                            disabled={selectedPriceModel.resellerId !== 0}
                        />
                        <Form.Check.Label className="ms-2 mb-0 mt-1">
                            Enable for Resellers
                        </Form.Check.Label>
                        {selectedPriceModel.resellerId !== 0 && 
                            <span>
                                <OverlayTrigger placement="right" overlay={<Tooltip style={{ width: '600px' }}>Enabled for resellers cannot be set to true when a Price Model is assigned to a reseller.</Tooltip>}>
                                    <InfoCircle className="ms-2" style={{}} />
                                </OverlayTrigger>
                            </span>}
                        
                        
                    </Form.Group>
                    <Form.Group className="mb-3 d-flex align-items-center" controlId="active">
                        <Form.Check.Input
                            type="checkbox"
                            style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                            }}
                            checked={!!selectedPriceModel.active}
                            onChange={handlePMActiveChange}
                        />
                        <Form.Check.Label className="ms-2 mb-0 mt-1">
                            Active
                        </Form.Check.Label>
                    </Form.Group>

                    <Form.Group className="mb-3 d-flex align-items-center" controlId="hideInPricelist">
                        <Form.Check.Input
                            type="checkbox"
                            style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                            }}
                            checked={!!selectedPriceModel.hideinPricelist}
                            onChange={handlePMHideInPricelistChange}
                        />
                        <Form.Check.Label className="ms-2 mb-0 mt-1">
                            Hide in Pricelist
                        </Form.Check.Label>
                    </Form.Group>

                    <Form.Group className="mb-3 d-flex align-items-center" controlId="nonSelectable">
                        <Form.Check.Input
                            type="checkbox"
                            style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                            }}
                            checked={!!selectedPriceModel.nonSelectable}
                            onChange={handlePMNonSelectableChange}
                        />
                        <Form.Check.Label className="ms-2 mb-0 mt-1">
                            Non-Selectable
                        </Form.Check.Label>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="weightage">
                        <Form.Label>Weightage</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Weightage"
                            value={selectedPriceModel.weightage ?? ''}
                            isInvalid={!pmValidation.isWeightageValid}
                            onChange={handlePMWeightageChange}
                            onKeyDown={blockInvalidChar}
                        />
                        <Form.Control.Feedback type="invalid">
                            {pmValidation.weightageErrorMessage}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Col>
        </Row>);
    };

    const bookField = () => {
        return (
            <Row>
                <Col md={6}>
                    <Form noValidate>
                        <Form.Group className="mb-3" controlId="priceBookName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Price Book Name"
                                value={selectedPriceBook.name}
                                isInvalid={!pbValidation.isNameValid}
                                onChange={handlePBNameChange}
                            />
                            <Form.Control.Feedback type="invalid">
                                {pbValidation.nameErrorMessage}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="accountCode">
                            <Form.Label>Account Code</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Account Code"
                                value={selectedPriceBook.accountCode}
                                onChange={handlePBAccountCodeChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="priceModelID">
                            <Form.Label>Price Model</Form.Label>
                            <Form.Select
                                value={selectedPriceBook.priceModelID || ''}
                                onChange={handlePBPriceModelIDChange}
                                isInvalid={!pbValidation.isPriceModelIDValid}
                            >
                                <option value="">Select Price Model</option>
                                {modelData.map((model) => (
                                    <option key={model.id} value={model.id}>
                                        {model.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {pbValidation.priceModelIDErrorMessage}
                            </Form.Control.Feedback>
                        </Form.Group>




                        <Form.Group className="mb-3" controlId="sband">
                            <Form.Label>Start Band</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Start Band"
                                value={selectedPriceBook.sband}
                                onChange={handlePBSBandChange}
                                onKeyDown={blockInvalidChar}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="eband">
                            <Form.Label>End Band</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="End Band"
                                value={selectedPriceBook.eband}
                                onChange={handlePBEBandChange}
                                onKeyDown={blockInvalidChar}
                            />
                        </Form.Group>
                    </Form>
                </Col>

                <Col md={6}>
                    <Form>
                        <Form.Group className="mb-3" controlId="type">
                            <Form.Label>Type</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Type"
                                value={selectedPriceBook.type}
                                onChange={handlePBTypeChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="price">
                            <Form.Label>Price</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Price"
                                value={selectedPriceBook.price}
                                onChange={handlePBPriceChange}
                                onKeyDown={blockInvalidChar}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="discount">
                            <Form.Label>Discount (%)</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Discount"
                                value={selectedPriceBook.discount}
                                onChange={handlePBDiscountChange}
                                onKeyDown={blockInvalidChar}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="currency">
                            <Form.Label>Currency</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Currency"
                                value={selectedPriceBook.currency}
                                onChange={handlePBCurrencyChange}
                            />
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        );
    };

    const featureField = () => {
        return (
            <Row>
                <Col md={6}>
                    <Form noValidate>
                        <Form.Group className="mb-3" controlId="priceModelID">
                            <Form.Label>Price Model</Form.Label>
                            <Form.Select
                                value={selectedUpdatedFeature.priceModelID || ''}
                                onChange={handlePFPriceModelIdChange}
                                isInvalid={!pfValidation.isPriceModelIDValid}
                            >
                                <option value="">Select Price Model</option>
                                {modelData.map((model) => (
                                    <option key={model.id} value={model.id}>
                                        {model.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {pfValidation.priceModelIDErrorMessage}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="featureName">
                            <Form.Label>Feature Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Feature Name"
                                value={selectedUpdatedFeature.featureName}
                                onChange={handlePFFeatureNameChange}
                                isInvalid={!pfValidation.isFeatureNameValid}
                            />
                            <Form.Control.Feedback type="invalid">
                                {pfValidation.featureNameErrorMessage}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="featureDescription">
                            <Form.Label>Feature Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter Feature Description"
                                value={selectedUpdatedFeature.featureDescription}
                                onChange={handlePFFeatureDescriptionChange}
                                isInvalid={!pfValidation.isFeatureDescriptionValid}
                            />
                            <Form.Control.Feedback type="invalid">
                                {pfValidation.featureDescriptionErrorMessage}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="sortOrder">
                            <Form.Label>Sort Order</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter Sort Order"
                                value={selectedUpdatedFeature.sortOrder}
                                onChange={handlePFSortOrderChange}
                                onKeyDown={blockInvalidChar}
                            />
                        </Form.Group>
                    </Form>
                </Col>

                <Col md={6}>
                    <Form>
                        <Form.Group className="mb-3" controlId="featureType">
                            <Form.Label>Feature Type</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Feature Type"
                                value={selectedUpdatedFeature.featureType}
                                onChange={handlePFFeatureTypeChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="featureValue">
                            <Form.Label>Feature Value</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Feature Value"
                                value={selectedUpdatedFeature.featureValue}
                                onChange={handlePFFeatureValueChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="featureUnit">
                            <Form.Label>Feature Unit</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter Feature Unit"
                                value={selectedUpdatedFeature.featureUnit}
                                onChange={handlePFFeatureUnitChange}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3 ps-3" controlId="smallPrint">
                            <Form.Check
                                type="checkbox"
                                label="Small Print"
                                checked={selectedUpdatedFeature.smallPrint}
                                onChange={handlePFSmallPrintChange}
                            />
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        );
    };

    const footerButtons = (buttonName,saveMethod) => {
        return (<>
            <Button variant="secondary" onClick={handleClose}>
                Close
            </Button>
            {buttonName !== "" && <Button variant="primary" onClick={saveMethod} >
                {buttonName}
            </Button>}
        </>);
    };

    const newPriceModel = () => {
        setSelectedPriceModel(defaultPriceModel);
        setShowModal(true);
        setModalHeader("NEW PRICE MODEL");
        setModalBody(modelField());
        setModalFooter(footerButtons("Create",
            () => {
                let isValid = true;

                const isNameValid = selectedPriceModel.name?.trim() !== "";
                if (!isNameValid) {
                    setPmValidation((prev) => ({
                        ...prev,
                        isNameValid: false,
                        nameErrorMessage: "Name is required."
                    }));
                    isValid = false;
                } else {
                    setPmValidation((prev) => ({
                        ...prev,
                        isNameValid: true,
                        nameErrorMessage: ""
                    }));
                }

                const isDescriptionValid = selectedPriceModel.description?.trim() !== "";
                if (!isDescriptionValid) {
                    setPmValidation((prev) => ({
                        ...prev,
                        isDescriptionValid: false,
                        descriptionErrorMessage: "Description is required."
                    }));
                    isValid = false;
                } else {
                    setPmValidation((prev) => ({
                        ...prev,
                        isDescriptionValid: true,
                        descriptionErrorMessage: ""
                    }));
                }

                const weightageValue = selectedPriceModel.weightage;
                const isWeightageValid = weightageValue !== null &&
                    weightageValue !== undefined &&
                    weightageValue !== "" &&
                    Number(weightageValue) > 0;

                if (!isWeightageValid) {
                    let message = "Weightage is required and should be greater than zero.";
                    setPmValidation((prev) => ({
                        ...prev,
                        isWeightageValid: false,
                        weightageErrorMessage: message
                    }));
                    isValid = false;
                } else {
                    setPmValidation((prev) => ({
                        ...prev,
                        isWeightageValid: true,
                        weightageErrorMessage: ""
                    }));
                }

                // Submit if all fields are valid
                if (isValid) {
                    savePriceModel();
                }
            }

        ));
    };

    useEffect(() => {
        if (modalHeader && modalHeader.includes('PRICE MODEL')) {
            if (modalHeader.includes("DELETE PRICE MODEL :")) {
                setModalBody(`Are you sure you want to delete this "${selectedPriceModel.name}" Model`);
                setModalFooter(footerButtons("DELETE",
                    () => {
                        DeletePM(selectedPriceModel);
                    }
                ));
            }
            else if (modalHeader !== 'COPY PRICE MODEL') {
                setModalBody(modelField());
                setModalFooter(footerButtons((modalHeader !== 'EDIT PRICE MODEL') ? "Create" : "Save",
                    () => {
                        let isValid = true;

                        // Validate name
                        const isNameValid = selectedPriceModel.name?.trim() !== "";
                        if (!isNameValid) {
                            setPmValidation((prev) => ({
                                ...prev,
                                isNameValid: false,
                                nameErrorMessage: "Name is required."
                            }));
                            isValid = false;
                        } else {
                            setPmValidation((prev) => ({
                                ...prev,
                                isNameValid: true,
                                nameErrorMessage: ""
                            }));
                        }

                        // Validate description
                        const isDescriptionValid = selectedPriceModel.description?.trim() !== "";
                        if (!isDescriptionValid) {
                            setPmValidation((prev) => ({
                                ...prev,
                                isDescriptionValid: false,
                                descriptionErrorMessage: "Description is required."
                            }));
                            isValid = false;
                        } else {
                            setPmValidation((prev) => ({
                                ...prev,
                                isDescriptionValid: true,
                                descriptionErrorMessage: ""
                            }));
                        }

                        // Validate weightage (must not be empty and must be > 0)
                        const weightageValue = selectedPriceModel.weightage;
                        const isWeightageValid = weightageValue !== null &&
                            weightageValue !== undefined &&
                            weightageValue !== "" &&
                            Number(weightageValue) > 0;

                        if (!isWeightageValid) {
                            let message = "Weightage is required and should be greater than zero.";
                            setPmValidation((prev) => ({
                                ...prev,
                                isWeightageValid: false,
                                weightageErrorMessage: message
                            }));
                            isValid = false;
                        } else {
                            setPmValidation((prev) => ({
                                ...prev,
                                isWeightageValid: true,
                                weightageErrorMessage: ""
                            }));
                        }

                        // Submit if all fields are valid
                        if (isValid) {
                            savePriceModel();
                        }
                    }

                ));
            }
            else {
                setModalBody(copyModelField);
                setModalFooter(footerButtons("CLONE",
                    () => {
                        clonePriceModel();
                    }
                ));
            }
        }
    }, [selectedPriceModel, modalHeader, pmValidation]);

    useEffect(() => {
        if (modalHeader && modalHeader.includes('PRICE FEATURE')) {
            if (modalHeader === "DELETE PRICE FEATURE :") {
                setModalBody(`Are you sure you want to delete this "${selectedUpdatedFeature.featureName}" FEATURE`);
                setModalFooter(footerButtons("DELETE",
                    () => {
                        DeletePF(selectedUpdatedFeature);
                    }
                ));
            }
            else if (modalHeader !== 'COPY PRICE FEATURE') {
                setModalBody(featureField());
                setModalFooter(footerButtons((modalHeader !== 'EDIT PRICE FEATURE') ? "Create" : "Save",
                    () => {
                        let isValid = true;
                        const isPriceModelValid = selectedUpdatedFeature.priceModelID > 0;
                        if (!isPriceModelValid) {
                            setPfValidation((prev) => ({
                                ...prev,
                                isPriceModelIDValid: false,
                                priceModelIDErrorMessage: 'Price Model must be selected'
                            }));
                            isValid = false;
                        } else {
                            setPfValidation((prev) => ({
                                ...prev,
                                isPriceModelIDValid: true,
                                priceModelIDErrorMessage: ''
                            }));
                        }
                        const isFeatureNameValid = selectedUpdatedFeature.featureName?.trim() !== "";
                        if (!isFeatureNameValid) {
                            setPfValidation((prev) => ({
                                ...prev,
                                isFeatureNameValid: false,
                                featureNameErrorMessage: "Feature Name is required.."
                            }));
                            isValid = false;
                        } else {
                            setPfValidation((prev) => ({
                                ...prev,
                                isFeatureNameValid: true,
                                featureNameErrorMessage: ""
                            }));
                        }
                        const isDescriptionValid = selectedUpdatedFeature.featureDescription?.trim() !== "";
                        if (!isDescriptionValid) {
                            setPfValidation((prev) => ({
                                ...prev,
                                isFeatureDescriptionValid: false,
                                featureDescriptionErrorMessage: "Feature Description is required."
                            }));
                            isValid = false;
                        } else {
                            setPfValidation((prev) => ({
                                ...prev,
                                isFeatureDescriptionValid: true,
                                featureDescriptionErrorMessage: ""
                            }));
                        }
                        if (isValid) {
                            savePriceFeature();
                        }
                    }
                ));
            }
        }
    }, [selectedUpdatedFeature, selectedExistingFeature, modalHeader, pfValidation])

    useEffect(() => {
        if (modalHeader === `DELETE PRICE BOOK :`) {
            setModalBody(`Are you sure you want to delete this "${selectedPriceBook.name}" BOOK`);
            setModalFooter(footerButtons("DELETE",
                () => {
                    DeletePB(selectedPriceBook);
                }
            ));
        }
        else if (modalHeader && modalHeader.includes('PRICE BOOK')) {
            setModalBody(bookField());
            setModalFooter(footerButtons((modalHeader !== 'EDIT PRICE BOOK') ? "Create" : "Save",
                () => {
                    let isValid = true;
                    if (selectedPriceBook.name.trim() === '') {
                        setPbValidation(prev => ({
                            ...prev,
                            isNameValid: false,
                            nameErrorMessage: 'Name should not be empty'
                        }));
                        
                        isValid = false;
                    }

                    if (selectedPriceBook.priceModelID === "" || selectedPriceBook.priceModelID <=0) {
                        setPbValidation(prev => ({
                            ...prev,
                            isPriceModelIDValid: false,
                            priceModelIDErrorMessage: 'Price Model must be selected'
                        }));

                        isValid = false;
                    }

                    if (isValid)
                        savePriceBook();
                }
            ));

        }

    }, [selectedPriceBook, modalHeader, pbValidation])

    const editPriceModel = (params) => {
        
        setSelectedPriceModel({
             ...params,
            resellerId: params.resellerID,
        });

        setShowModal(true);
        setModalHeader("EDIT PRICE MODEL");
        setModalBody(modelField());
        setModalFooter(footerButtons("Save",
            () => {
                let isValid = true;

                // Validate name
                const isNameValid = selectedPriceModel.name?.trim() !== "";
                if (!isNameValid) {
                    setPmValidation((prev) => ({
                        ...prev,
                        isNameValid: false,
                        nameErrorMessage: "Name is required."
                    }));
                    isValid = false;
                } else {
                    setPmValidation((prev) => ({
                        ...prev,
                        isNameValid: true,
                        nameErrorMessage: ""
                    }));
                }

                // Validate description
                const isDescriptionValid = selectedPriceModel.description?.trim() !== "";
                if (!isDescriptionValid) {
                    setPmValidation((prev) => ({
                        ...prev,
                        isDescriptionValid: false,
                        descriptionErrorMessage: "Description is required."
                    }));
                    isValid = false;
                } else {
                    setPmValidation((prev) => ({
                        ...prev,
                        isDescriptionValid: true,
                        descriptionErrorMessage: ""
                    }));
                }
                const weightageValue = selectedPriceModel.weightage;
                const isWeightageValid = weightageValue !== null &&
                    weightageValue !== undefined &&
                    weightageValue !== "" &&
                    Number(weightageValue) > 0;
                if (!isWeightageValid) {
                    let message = "Weightage is required and should be greater than zero.";
                    setPmValidation((prev) => ({
                        ...prev,
                        isWeightageValid: false,
                        weightageErrorMessage: message
                    }));
                    isValid = false;
                } else {
                    setPmValidation((prev) => ({
                        ...prev,
                        isWeightageValid: true,
                        weightageErrorMessage: ""
                    }));
                }
                if (isValid) {
                    savePriceModel();
                }
            }
        ));
    };

    const newPriceFeature = () => {
        setSelectedExistingFeature(null);
        setSelectedUpdatedFeature(defaultPriceFeature);
        setShowModal(true);
        setModalHeader("NEW PRICE FEATURE");
        setModalBody(featureField());
        setModalFooter(footerButtons("Create",

            () => {
                let isValid = true;

                // Validate name
                const isFeatureNameValid = selectedUpdatedFeature.featureName?.trim() !== "";
                if (!isFeatureNameValid) {
                    setPfValidation((prev) => ({
                        ...prev,
                        isFeatureNameValid: false,
                        featureNameErrorMessage: "Feature Name is required."
                    }));
                    isValid = false;
                } else {
                    setPfValidation((prev) => ({
                        ...prev,
                        isFeatureNameValid: true,
                        featureNameErrorMessage: ""
                    }));
                }

                // Validate description
                const isDescriptionValid = selectedUpdatedFeature.featureDescription?.trim() !== "";
                if (!isDescriptionValid) {
                    setPfValidation((prev) => ({
                        ...prev,
                        isFeatureDescriptionValid: false,
                        featureDescriptionErrorMessage: "Feature Description is required."
                    }));
                    isValid = false;
                } else {
                    setPfValidation((prev) => ({
                        ...prev,
                        isFeatureDescriptionValid: true,
                        featureDescriptionErrorMessage: ""
                    }));
                }

                if (isValid) {
                    savePriceFeature();
                }
            }
        ));
    };

    const editPriceFeature = (params) => {
        const data = JSON.parse(JSON.stringify(params))
        setSelectedExistingFeature(data);
        setSelectedUpdatedFeature(params);
        setShowModal(true);
        setModalHeader("EDIT PRICE FEATURE");
        setModalBody(featureField());
        setModalFooter(footerButtons("Save",
            () => {
                savePriceFeature();
            }
        ));
    };

    const newPriceBook = () => {
        setSelectedPriceBook(defaultPriceBook);
        setPbValidation(defaultPbValidation);
        setShowModal(true);
        setModalHeader("NEW PRICE BOOK");
        setModalBody(bookField());
        setModalFooter(footerButtons("Create", 
            () => {
                savePriceBook();
            }
        ));
    };

    const editPriceBook = (params) => {
        setSelectedPriceBook(params);
        setPbValidation(defaultPbValidation);
        setShowModal(true);
        setModalHeader("EDIT PRICE BOOK");
        setModalBody(bookField());
        setModalFooter(footerButtons("Save",
            () => {
                savePriceBook();
            }
        ));
    };

    //const createOrSelectFeatures = () => {
    //    setModalHeader("FEATURES");
    //    setModalBody(null);
    //    setModalFooter(modelButtons(true,
    //        () => {
    //            savePriceModel();
    //            createOrSelectBooks();
    //        }
    //    ));
    //};

    //const createOrSelectBooks = () => {
    //    setModalHeader("BOOKS");
    //    setModalBody(null);
    //    setModalFooter(modelButtons(false, handleClose));
    //};
    const onRowClicked = (params) => {
        setActiveModelId(params.data.id ?? null);
    };    

    const summaryPm = (params) => {

        const currentPriceModel = params.node.data;
        const priceModelId = currentPriceModel.id;

        let relatedFeatures = JSON.parse(JSON.stringify(featureData.filter(feature => feature.priceModelID === priceModelId)));
        let relatedBooks = JSON.parse(JSON.stringify(bookData.filter(book => book.priceModelID === priceModelId)));
        let popupFeatureCol = JSON.parse(JSON.stringify(featureColDef.filter((_, index) => index !== 0 && index !== 1 && index !== 3)));
        let popupBookCol = JSON.parse(JSON.stringify(bookColDef.filter((_, index) => index !== 0 && index !== 1 && index !== 4)));
        const popUpTable = () => (
            <div>
                <div className="card mt-1" id="priceModel">
                    <div className="card-header p-1 d-flex align-items-center justify-content-between">
                        <span className="SectionTitle ms-2 fw-medium">
                            Price Features
                        </span>
                    </div>
                </div>
                <div className="ag-theme-alpine" style={{ height: "300px", overflow: "auto", marginBottom: "20px" }}>
                        <AgGridReact
                            rowData={relatedFeatures}
                            columnDefs={popupFeatureCol}
                            domLayout="normal"
                            defaultColDef={defaultColDef}
                        />
                </div>
                <div className="card mt-1" id="priceModel" style={{}}>
                    <div className="card-header p-1 d-flex align-items-center justify-content-between">
                        <span className="SectionTitle ms-2 fw-medium">
                            Price Books
                        </span>
                    </div>
                </div>
                <div className="ag-theme-alpine" style={{ height: "300px", overflow: "auto" }}>
                        <AgGridReact
                            rowData={relatedBooks}
                            columnDefs={popupBookCol}
                            defaultColDef={defaultColDef}
                            domLayout="normal"
                        />
                </div>
            </div>
        );
        setShowModal(true);
        setModalHeader(`FOR MODEL : ${currentPriceModel.name}`);
        setModalBody(popUpTable);
        setModalFooter(null);
    };


    useEffect(() => {
        getPriceDetails();
    }, []); 

    useEffect(() => {
        setModelColDef([
            { headerName: "ID", field: "id", width: 70, sortable: true, filter: true, },
            {
                headerName: 'Options', width: 100, sortable: false,
                cellRenderer: (params) => {

                    return (
                        <div className="justify-content-between d-flex align-items-center">

                            <button className="a-icon" onClick={() => {
                                
                                editPriceModel(params.node.data);
                            }
                            }>
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Edit Price Model" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                            <button className="a-icon" onClick={() => { copyPriceModel(params) }}
                            >
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Copy Price Model" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                            <button className="a-icon" onClick={() => { confirmDeletePm(params) }}>
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Remove Price Model" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                            <button className="a-icon" onClick={() => { summaryPm(params) }}>
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Summary Price Model" })}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-eye"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                    </svg>
                                </OverlayTrigger>
                            </button>

                        </div>
                    );
                },
            },

            {
                headerName: "Name", field: "name", sortable: true, filter: true,
                cellRenderer: (params) => {


                    return (
                        <div className="justify-content-between d-flex align-items-center">
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: params.value })}>
                                <div>{params.value}</div>
                            </OverlayTrigger>
                        </div>
                    );
                }
            },
            {
                headerName: "Description", field: "description", sortable: true, filter: true,
                cellRenderer: (params) => {


                    return (
                        <div className="justify-content-between d-flex align-items-center">
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: params.value })}>
                                <div>{params.value}</div>
                            </OverlayTrigger>
                        </div>
                    );
                }
            },
            {
                headerName: "Reseller", field: "resellerID", sortable: true, filter: true,
                cellStyle: { textAlign: 'center' },
                headerClass: 'ag-header-center',
                cellRenderer: (params) => {
                    return resellerMap.get(params.value) || ` `;
                },
                filterValueGetter: (params) => {
                    return resellerMap.get(params.data.resellerID) || ` `;
                },
                keyCreator: (params) => {
                    return resellerMap.get(params.value) || ` `;
                }
            },
            {
                headerName: "Term (Months)", field: "term", cellStyle: { textAlign: 'center' }, sortable: true, filter: true, cellRenderer: (params) => params.value || " " },
            { headerName: "Family", field: "family", cellStyle: { textAlign: 'center' }, sortable: true, filter: true, cellRenderer: (params) => params.value || " " },
            { headerName: "Partner Discount (%)", cellStyle: { textAlign: 'center' }, field: "partnerDiscount", sortable: true, filter: true, cellRenderer: (params) => params.value || " " },
            { headerName: "PAYG", field: "payg", cellStyle: { textAlign: 'center' }, sortable: true, filter: true, cellRenderer: (params) => params.value || " " },
            { headerName: "Active", field: "active", cellStyle: { textAlign: 'center' }, sortable: true, filter: true, cellRenderer: booleanCellRenderer },
            { headerName: "Invoice Description", field: "invoiceDesc", sortable: true, filter: true, cellRenderer: (params) => params.value || " " },
            { headerName: "CW Direct Product ID", field: "cwDirectProductID", sortable: true, filter: true, cellRenderer: (params) => params.value || " " },
            { headerName: "CW Partner Product ID", field: "cwPartnerProductID", sortable: true, filter: true, cellRenderer: (params) => params.value || " " },
            { headerName: "PAYG Partner Disk Discount", field: "paygPartnerDiskDiscount", sortable: true, filter: true, cellRenderer: (params) => params.value || " " },
            { headerName: "Enable for Resellers", field: "isResellerEnabled", sortable: true, filter: true, cellRenderer: booleanCellRenderer },

            { headerName: "Hide in Pricelist", field: "hideinPricelist", sortable: true, filter: true, cellRenderer: booleanCellRenderer },
            { headerName: "Non-Selectable", field: "nonSelectable", sortable: true, filter: true, cellRenderer: booleanCellRenderer },
            { headerName: "Weightage", field: "weightage", sortable: true, filter: true, cellRenderer: (params) => params.value || " " }
        ]);
        setFeatureColDef([
            {
                headerName: "S.No",
                valueGetter: (params) => params.node.rowIndex + 1,  
                width: 70,  
                sortable: false,
                filter: false,
                resizable: false,
            },
            {
                headerName: 'Options', sortable: false, width: 85, //checkboxSelection: true, headerCheckboxSelection: true,
                cellRenderer: (params) => {

                    return (
                        <div className="justify-content-between d-flex align-items-center">

                            <button className="a-icon" onClick={() => { editPriceFeature(params.node.data); }}>
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Edit Price Feature" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                            <button className="a-icon" onClick={() => { confirmDeletePf(params) }}>
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Remove Price Feature" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                    </svg>
                                </OverlayTrigger>
                            </button>

                        </div>
                    );
                },
            },
            {
                headerName: "Feature Name",
                field: "featureName",
                sortable: true,
                filter: true,
                width: 170,
                
                cellRenderer: (params) => {


                    return (
                        <div className="justify-content-between d-flex align-items-center">
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: params.value })}>
                                <div>{params.value}</div>
                            </OverlayTrigger>
                        </div>
                    );
                }
            },
            {
                headerName: "Price Model",
                field: "priceModelID",
                sortable: true,
                filter: 'agTextColumnFilter',
                width: 125,
                cellStyle: { textAlign: 'center' },
                filterValueGetter: (params) => {
                    return modelNameMap.get(params.data.priceModelID) || '';
                },
                keyCreator: (params) => {
                    return modelNameMap.get(params.value) || '';
                },
                cellRenderer: (params) => {
                    return modelNameMap.get(params.value) || ` `;
                }
            },
            {
                headerName: "Feature Description",
                field: "featureDescription",
                sortable: true,
                filter: true,
                width: 190,
                cellRenderer: (params) => {


                    return (
                        <div className="justify-content-between d-flex align-items-center">
                            <OverlayTrigger key="sort-1" placement="left" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: params.value })}>
                                <div>{params.value}</div>
                            </OverlayTrigger>
                        </div>
                    );
                }
            },
            {
                headerName: "Sort Order",
                field: "sortOrder",
                sortable: true,
                filter: true,
                width: 125,
                cellStyle: { textAlign: 'center' },
                cellRenderer: (params) => params.value ?? " "
            },
            {
                headerName: "Feature Type",
                field: "featureType",
                sortable: true,
                filter: true,
                width: 145,
                cellStyle: { textAlign: 'center' },
                cellRenderer: (params) => params.value || " "
            },
            {
                headerName: "Feature Value",
                field: "featureValue",
                sortable: true,
                filter: true,
                width: 145,
                cellStyle: { textAlign: 'center' },
                cellRenderer: (params) => params.value || " "
            },
            {
                headerName: "Feature Unit",
                field: "featureUnit",
                sortable: true,
                filter: true,
                width: 145,
                cellStyle: { textAlign: 'center' },
                cellRenderer: (params) => params.value || " "
            },
            {
                headerName: "Small Print",
                field: "smallPrint",
                sortable: true,
                filter: true,
                width: 125,
                cellStyle: { textAlign: 'center' },
                cellRenderer: booleanCellRenderer
            }
        ]);
        setBookColDef([
            {
                headerName: 'ID',
                field: 'id',
                sortable: true,
                filter: true,
                width: 80,
            },
            {
                headerName: 'Options', width: 85, sortable: false,
                cellRenderer: (params) => {

                    return (
                        <div className="justify-content-between d-flex align-items-center">

                            <button className="a-icon" onClick={() => { editPriceBook(params.node.data); }}>
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Edit Price Book" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                    </svg>
                                </OverlayTrigger>
                            </button>
                            <button className="a-icon" onClick={() => { confirmDeletePb(params); }}>
                                <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: "Remove Price Book" })}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                    </svg>
                                </OverlayTrigger>
                            </button>

                        </div>
                    );
                },
            },
            {
                headerName: 'Name',
                field: 'name',
                sortable: true,
                filter: true,
                width: 230,
                cellRenderer: (params) => {

                    return (
                        <div className="justify-content-between d-flex align-items-center">
                            <OverlayTrigger key="sort-1" placement="top" delay={{ show: 50, hide: 50 }} overlay={(props) => renderTooltip({ ...props, id: "sort-1", text: params.value })}>
                                <div>{params.value}</div>
                            </OverlayTrigger>
                        </div>
                    );
                }
            },
            {
                headerName: 'Account Code',
                field: 'accountCode',
                sortable: true,
                filter: true,
                cellStyle: { textAlign: 'center' },
                width: 138,
            },
            {
                headerName: 'Price Model',
                field: 'priceModelID',
                filter: 'agTextColumnFilter',
                sortable: true,
                ////filter: true,
                width: 135,
                cellStyle: { textAlign: 'center' },
                ////filter: 'agTextColumnFilter',
                filterValueGetter: (params) => {
                    return modelNameMap.get(params.data.priceModelID) || '';
                },
                keyCreator: (params) => {
                    return modelNameMap.get(params.value) || '';
                },
                cellRenderer: (params) => {
                    const modelName = modelNameMap.get(params.value) || '';

                    return (
                        <div className="justify-content-between d-flex align-items-center">
                            <OverlayTrigger
                                key="sort-1"
                                placement="top"
                                delay={{ show: 50, hide: 50 }}
                                overlay={(props) =>
                                    renderTooltip({ ...props, id: "sort-1", text: modelName })
                                }
                            >
                                <div>{modelName}</div>
                            </OverlayTrigger>
                        </div>
                    );
                }
            },
            {
                headerName: 'Start Band',
                field: 'sband',
                sortable: true,
                filter: true,
                cellStyle: { textAlign: 'center' },
                width: 120,
            },
            {
                headerName: 'End Band',
                field: 'eband',
                sortable: true,
                filter: true,
                cellStyle: { textAlign: 'center' },
                width: 120,
            },
            {
                headerName: 'Type',
                field: 'type',
                sortable: true,
                filter: true,
                cellStyle: { textAlign: 'center' },
                width: 100,
            },
            {
                headerName: 'Price',
                field: 'price',
                sortable: true,
                filter: true,
                width: 100,
                cellStyle: { textAlign: 'center' },
                valueFormatter: (params) => `${params.value.toFixed(2)}`,
            },
            {
                headerName: 'Discount (%)',
                field: 'discount',
                sortable: true,
                filter: true,
                cellStyle: { textAlign: 'center' },
                width: 138,
            },
            {
                headerName: 'Currency',
                field: 'currency',
                sortable: true,
                filter: true,
                cellStyle: { textAlign: 'center' },
                width: 110,
            }]);

    }, [modelData, featureData, bookData])

    const reloadPriceModel = async () => {
        try {
            setModelLoading(true);
            const priceModels = await Axios.get(API_ROUTE + Routes.GET_ALL_PRICE_MODELS, await config());
            if (priceModels?.data) 
                setModelData(priceModels.data);
            setModelLoading(false);
        }
        catch (reason) {
            toast.error(reason);
            setModelLoading(false);
        }
    };

    const reloadPriceFeature = async () => {
        try {
            setFeatureLoading(true);
            const priceFeatures = await Axios.get(API_ROUTE + Routes.GET_ALL_PRICE_FEATURES, await config());
            if (priceFeatures?.data) 
                setFeatureData(priceFeatures.data);
            setFeatureLoading(false);
        }
        catch (reason) {
            toast.error(reason);
            setFeatureLoading(false);
        }

    };

    const reloadPriceBook = async () => {
        try {
            setBookLoading(true);
            const priceBooks = await Axios.get(API_ROUTE + Routes.GET_ALL_PRICE_BOOKS, await config());
            if (priceBooks?.data) 
                setBookData(priceBooks.data);
            setBookLoading(false);
        }
        catch (reason) {
            toast.error(reason);
            setBookLoading(false);
        }
    };

    async function getPriceDetails() {
        try {
            getResellers();
            reloadPriceModel();
            reloadPriceFeature();
            reloadPriceBook();
        } catch (error) {
            toast.error("Unable to get Tables detail")
            if (error?.response?.status === 440) {
                window.location.href = "/TimeoutErrorHandler";
            }
        } 
    }

    const onGridPmReady = params => {
        setGridPmApi(params.api);
        ////setGridPmColumnApi(params.columnApi);
    };

    const onGridPfReady = params => {
        setGridPfApi(params.api);
        ////setGridPfColumnApi(params.columnApi);
    };
    const onGridPbReady = params => {
        setGridPbApi(params.api);
        ////setGridPbColumnApi(params.columnApi);
    };

    const clearAllPmFilters = () => {
        if (gridPmApi) {
            gridPmApi.setFilterModel(null);
            gridPmApi.onFilterChanged();
        }
        setActiveModelId(null);
        clearAllPfFilters();
        clearAllPbFilters();
    };

    const clearAllPfFilters = () => {
        if (gridPfApi) {
            gridPfApi.setFilterModel(null);         
            gridPfApi.onFilterChanged();            
        }
    };

    const clearAllPbFilters = () => {
        if (gridPbApi) {
            gridPbApi.setFilterModel(null);         
            gridPbApi.onFilterChanged();            
        }
    };

    //const onButtonClick = () => {
    //    const selectedNodes = gridPfRef.current.api.getSelectedNodes();
    //    const selectedData = selectedNodes.map(node => node.data);
    //    console.log(selectedData);
    //};

    const PriceModelTable = (
        <div id="priceModelHeader" className="ag-theme-alpine" style={{ height: "350px", overflow: "auto" }}>
            {modelLoading ? (  // Show loader while data is loading
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100px" }}>
                    <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                </div>
            ) : (
                    <AgGridReact
                        onGridReady={onGridPmReady}
                        rowData={modelData}
                        columnDefs={modelColDef}
                        onRowClicked={onRowClicked}
                        rowSelection={{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }}
                        defaultColDef={defaultColDef}
                        domLayout='normal'
                    />
            )}
        </div>
    );

    const PriceFeatureTable = (
        <div className="ag-theme-alpine" style={{ height: "350px", overflow: "auto" }}>
            {featureLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100px" }}>
                    <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                </div>
            ) : (
                    <AgGridReact
                        ref={gridPfRef }
                        onGridReady={onGridPfReady}
                        rowData={activeModelId ? featureData.filter(f => f.priceModelID === activeModelId) : []}
                        columnDefs={featureColDef}
                        domLayout="normal"
                        defaultColDef={defaultColDef}
                        rowSelection={{ mode: 'multiRow', checkboxes: false, enableClickSelection: true }}
                    />
            )}
        </div>
    );

    const PriceBookTable = (
        <div className="ag-theme-alpine" style={{ height: "350px", overflow: "auto" }}>
            {bookLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100px" }}>
                    <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                </div>
            ) : (
                    <AgGridReact
                        onGridReady={onGridPbReady}
                        rowData={activeModelId ? bookData.filter(b => b.priceModelID === activeModelId) : []}
                        columnDefs={bookColDef}
                        defaultColDef={defaultColDef}
                        domLayout="normal"
                    />
            )}
        </div>
    );
    
    return (
        <React.Fragment>
        <Container width='100%' id="setting_container">
            <NavBar page="pricemanagement" authContext={authContext} />
            <div className="row p-0 me-1" style={{ maxHeight: '92vh', overflowY: 'auto', overflowX: 'hidden' }}>
            <div>
                <Col sm={12}>
                    <Col md={12}>
                        <Card id="TenantSettings" style={{ margin: '0 11px' }}>
                            <Card.Header
                                className="setting_header SectionTitle"
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <div><b>PRICE LIST MANAGEMENT</b></div>
                            </Card.Header>
                        </Card>
                    </Col>
                </Col>
            </div>
            <div style={{ padding: "0px 20px 0px 20px" }}>
                <div className="card mt-1" id="priceModel">
                <div className="card-header p-1 d-flex align-items-center">
                    <span className="SectionTitle ms-2" style={{ fontWeight: '500', width: '50%' }}> Price Model</span>
                    <div className="d-flex justify-content-end " style={{ width: '50%' }}>
                        <div className="col-md-6 pe-3 d-flex justify-content-end align-items-center" >
                            <span className="SectionTitle" style={{  cursor: 'pointer' }} >
                                            <button className="a-icon a-btn" id="CreatePricelModelBtn"
                                    onClick={() => {
                                        newPriceModel();
                                    }}

                                >
                                    <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                        <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                        </path>
                                    </svg>
                                    &nbsp; New Price Model &nbsp;
                                </button>

                                            <button className="a-icon" id="PriceModel_btnReload" title="Refresh" onClick={() => { reloadPriceModel(); }}>

                                    <svg style={{ marginBottom: '.1rem' }} className="me-2 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512">
                                        <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                                        </path>
                                    </svg> </button>
                                            <button id="ContentPlaceHolder1_btnClear" title="Clear Filter" style={{ cursor: 'pointer', height: "25", width: "25" }} className="me-1 mainpage_clear a-icon" onClick={clearAllPmFilters}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="23" fill="#007bff" stroke="currentColor" viewBox="0 0 32 32" width="23" style={{ cursor: 'pointer' }}>
                                        <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                                        <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                                    </svg>
                                </button>
                                            <button className="a-icon" id="ContentPlaceHolder1_btnDownload" title="Download" onClick={() => {
                                    if (gridPmApi) {
                                        gridPmApi.exportDataAsCsv({
                                            fileName: 'PriceModel.csv'
                                        });

                                    }
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" className="mb-1 me-2">
                                        <path fill="currentColor" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z">
                                        </path>
                                    </svg> </button>
                            </span>
                        </div>
                    </div>
                    </div> 
                </div>
                <div className="card-body p-0">
                    {PriceModelTable}
                </div>
                <div style={{ display: 'flex', gap: '10px', paddingTop: '10px' }}>
                    {/* Price Feature Grid Container */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <div className="card mt-1" id="priceModel">
                        <div className="card-header p-1 d-flex align-items-center justify-content-between">
                            <span className="SectionTitle ms-2 fw-medium">
                                Price Feature
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-feature">Select a Price Model from above</Tooltip>}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="ms-2 bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                    </svg>
                                </OverlayTrigger>
                            </span>

                            <div className="col-md-6 pe-3 d-flex justify-content-end align-items-center" >
                                <span className="SectionTitle" style={{  cursor: 'pointer' }} >
                                                <button className="a-icon a-btn" id="CreateNewPriceFeatureBtn"
                                        onClick={() => {
                                            newPriceFeature();
                                        }}

                                    >
                                        <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                            </path>
                                        </svg>
                                        &nbsp; New Price Feature &nbsp;
                                    </button>

                                                <button className="a-icon" id="PriceFeature_btnReload" title="Refresh" onClick={() => { reloadPriceFeature(); }}>

                                        <svg style={{ marginBottom: '.1rem' }} className="me-1 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                                            </path>
                                        </svg> </button>
                                                <button id="ContentPlaceHolder1_btnClear" title="Clear Filter" style={{ cursor: 'pointer', height: "25", width: "25" }} className="me-1 mainpage_clear a-icon" onClick={clearAllPfFilters}>
                                        <svg xmlns="http://www.w3.org/2000/svg" height="23" fill="#007bff" stroke="currentColor" viewBox="0 0 32 32" width="23" style={{ cursor: 'pointer' }}>
                                            <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                                            <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                                        </svg>
                                    </button>
                                                <button className="a-icon" id="ContentPlaceHolder1_btnDownload" title="Download" onClick={() => {
                                        if (gridPfApi) {
                                            gridPfApi.exportDataAsCsv(
                                                {
                                                    fileName: 'PriceFeature.csv'
                                                });

                                        }
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" className="mb-1 me-2">
                                            <path fill="currentColor" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z">
                                                        </path>
                                                    </svg> </button>
                                </span>
                            </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            {PriceFeatureTable}
                        </div>
                    </div>

                    {/* Price Book Grid Container */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <div className="card mt-1" id="priceModel">
                        <div className="card-header p-1 d-flex align-items-center justify-content-between">
                            <span className="SectionTitle ms-2 fw-medium">
                                Price Book
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-book">Select a Price Model from above</Tooltip>}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="ms-2 bi bi-info-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                    </svg>
                                </OverlayTrigger>
                            </span>
                            <div className="col-md-6 pe-3 d-flex justify-content-end align-items-center" >
                                <span className="SectionTitle" style={{  cursor: 'pointer' }} >
                                                <button className="a-icon a-btn" id="CreateNewPriceBookBtn"
                                        onClick={() => {
                                            newPriceBook();
                                        }}

                                    >
                                        <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                            </path>
                                        </svg>
                                        &nbsp; New Price Book &nbsp;
                                    </button>

                                                <button className="a-icon" id="PriceBook_btnReload" title="Refresh" onClick={() => { reloadPriceBook(); }}>

                                        <svg style={{ marginBottom: '.1rem' }} className="me-1 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 512 512">
                                            <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                                            </path>
                                        </svg> </button>
                                                <button id="ContentPlaceHolder1_btnClear" title="Clear Filter" style={{ cursor: 'pointer', height: "25", width: "25" }} className="me-1 mainpage_clear a-icon" onClick={clearAllPbFilters}>
                                        <svg xmlns="http://www.w3.org/2000/svg" height="23" fill="#007bff" stroke="currentColor" viewBox="0 0 32 32" width="23" style={{ cursor: 'pointer' }}>
                                            <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                                            <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                                        </svg>
                                    </button>
                                                <button className="a-icon" id="ContentPlaceHolder1_btnDownload" title="Download" onClick={() => {
                                        if (gridPbApi) {
                                            gridPbApi.exportDataAsCsv(
                                                {
                                                    fileName: 'PriceBook.csv'
                                                });

                                        }
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" className="mb-1 me-2">
                                            <path fill="currentColor" d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z">
                                            </path>
                                        </svg> </button>
                                </span>
                            </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            {PriceBookTable}
                        </div>
                    </div>
                </div>
            </div>
            <PriceListPopUpModal showModal={showModal} handleClose={handleClose} modalHeader={modalHeader} modalBody={modalBody} modalFooter={modalFooter} />
            </div>
            </Container>
            </React.Fragment>
    );


};
export default PriceManagement;

